import axiosInstance from '../../services/axiosConfig';

const influencerActivityService = {
  /**
   * Track view for a campaign advertising
   * @param {string} campaignAdvertisingId - The campaign advertising ID
   */
  trackView: async (campaignAdvertisingId) => {
    try {
      const response = await axiosInstance.post(
        `/company/campaigns/advertising/${campaignAdvertisingId}/track-view`
      );
      return response.data;
    } catch (error) {
      // Don't throw error for view tracking - it's not critical
      console.error('Error tracking view:', error);
      return { success: false, totalViews: 0 };
    }
  },

  /**
   * Toggle like for a campaign advertising
   * @param {string} campaignAdvertisingId - The campaign advertising ID
   */
  toggleLike: async (campaignAdvertisingId) => {
    try {
      const response = await axiosInstance.post(
        `/company/campaigns/advertising/${campaignAdvertisingId}/toggle-like`
      );
      return response.data;
    } catch (error) {
      console.error('Error toggling like:', error);
      throw new Error(
        error.response?.data?.message ||
        error.response?.data?.error ||
        'Failed to toggle like'
      );
    }
  },

  /**
   * Toggle bookmark for a campaign advertising
   * @param {string} campaignAdvertisingId - The campaign advertising ID
   */
  toggleBookmark: async (campaignAdvertisingId) => {
    try {
      const response = await axiosInstance.post(
        `/company/campaigns/advertising/${campaignAdvertisingId}/toggle-bookmark`
      );
      return response.data;
    } catch (error) {
      console.error('Error toggling bookmark:', error);
      throw new Error(
        error.response?.data?.message ||
        error.response?.data?.error ||
        'Failed to toggle bookmark'
      );
    }
  },

  /**
   * Get user activity for a campaign advertising
   * @param {string} campaignAdvertisingId - The campaign advertising ID
   */
  getUserActivity: async (campaignAdvertisingId) => {
    try {
      const response = await axiosInstance.get(
        `/company/campaigns/advertising/${campaignAdvertisingId}/activity`
      );
      return response.data;
    } catch (error) {
      // Return default values if error (user not logged in, etc.)
      console.error('Error fetching user activity:', error);
      return {
        success: true,
        data: {
          liked: false,
          bookmarked: false,
          viewed: false,
          totalViews: 0,
          totalLikes: 0
        }
      };
    }
  }
};

export default influencerActivityService;

